import { createActionGroup, props } from '@ngrx/store';
import { InstalledApplication } from './mdm-installed-applications.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmInstalledApplicationsResolverActions = createActionGroup({
  source: 'MdmInstalledApplications Resolver',
  events: {
    'Installed Applications Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MdmInstalledApplicationsApiActions = createActionGroup({
  source: 'MdmInstalledApplications API',
  events: {
    'Installed Applications Loaded': props<{ installedApplications: InstalledApplication[]; udid: string }>(),
    'Installed Applications Loaded Error': props<{ error: ErrorModel }>(),
  },
});
